module.exports = __webpack_public_path__ + "media/images/megamenu_about_publishing_promo_image-e129187ae2928482c837a7485325b6d1.png";